import React from "react";
import { 
  FaFacebookF, 
  FaTwitter, 
  FaLinkedinIn, 
  FaInstagram, 
  FaYoutube,
  FaGooglePlay,
  FaApple
} from "react-icons/fa";

import { motion } from "framer-motion";
import "./Footer.css";
import { useNavigate ,Link} from "react-router-dom";
import logo from '../Images/Jayraj_logo.png'

function Footer() {
  const navigate = useNavigate()
  return (
    <motion.footer 
      className="footer"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
            {/* OFFICE LOCATIONS */}
<div className="footer-offices">
  <h3 className="office-title">Our Offices</h3>

  <div className="office-wrapper">
    {/* OFFICE DETAILS */}
    <div className="office-list">

      <div className="office-card">
        <h4>Head Office – Uttarakhand</h4>
        <p>
          Jayraj Group, Semitalli, Kedarnath Main Road,<br />
          Guptkashi, Dist. Rudraprayag,<br />
          Uttarakhand – 246439
        </p>
        <span>📞 8869872377</span>
      </div>

      {/* <div className="office-card">
        <h4>Branch Office – Vadodara</h4>
        <p>
          Jayraj Group, 1st Floor Siddharth Magnum Plus,<br />
          Beside Bansal Mall, Tarsali Danteshwar Ring Road,<br />
          Vadodara, Gujarat – 390009
        </p>
        <span>📞 Payal Shah – 9537907801</span>
      </div> */}

      <div className="office-card">
        <h4>Branch Office – Haridwar</h4>
        <p>
          Jayraj Group, Bhagirathi Nagar, Bhupatwala,<br />
          Behind Nainital Bank,<br />
          Haridwar – 249401
        </p>
        <span>📞 7900777422</span>
      </div>

    </div>

    {/* MAP */}
    <div className="office-map">
<iframe
  title="Jayraj Group Head Office Map"
  src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d3539.8291084078237!2d79.08066107538033!3d30.523836087095916!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1skedarnath%20main%20road%20guptkashi%20dist%20rudraprayag%20uttrakhand%20246439!5e1!3m2!1sen!2sin!4v1769932612847!5m2!1sen!2sin"
  width="100%"
  height="100%"
  style={{ border: 0 }}
  allowFullScreen=""
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
/>

    </div>
  </div>
</div>
      <div className="footer-container">

        {/* Brand Column */}
        <div className="footer-col">
           <img src={logo} alt="Jayraj Group Logo" width="100px" height="100px" onClick={()=>navigate("/")}/>
        
          <p className="footer-desc">
            <strong>Jayraj Group</strong> Building dreams, creating value.<br/>
            Your trusted partner in premium Jayraj Group.
          </p>
            {/* App Download Section */}
<div className="app-download">
  <span className="footer-heading" style={{marginTop:"0px",textAlign:"center",color:"gold"}}>DOWNLOAD APP</span>

  <div className="store-buttons">

    <a
      href="https://play.google.com/store/apps/details?id=com.himangshu101.jayrajtravel"
      target="_blank"
      rel="noopener noreferrer"
      className="store-btn playstore"
    >
      <FaGooglePlay className="store-icon" />
      <span><strong>Google Play</strong></span>
    </a>

    <a
      href="https://apps.apple.com/us/app/jayraj-travel-hotel-booking/id6759034839"
      target="_blank"
      rel="noopener noreferrer"
      className="store-btn appstore"
    >
      <FaApple className="store-icon" />
      <span><strong>App Store</strong></span>
    </a>

  </div>
</div>

         
        </div>

        {/* Quick Links */}
        <div className="footer-col" style={{display:"flex",flexDirection:"column"}}>
          <h4 className="footer-heading">QUICK LINKS</h4>
          <div className="quicklinks">
          <ul>
            {/* <li><Link to="/">Home</Link></li> */}
            <li><Link to="/tour/grouptour">Group Tour</Link></li>
            <li><Link to="/tour/packagetour">Package Tour</Link></li>
            <li><Link to="/tour/plantour">Plan Tour</Link></li>
            <li><Link to="/tour/weekendtour">Weekend Tour</Link></li>

          </ul>
          <ul>
            <li><Link to="/hotels">Hotels</Link></li>
            <li><Link to="/activities">Activity</Link></li>
            <li><Link to="/transports">Transport</Link></li>
            <li><Link to="/become-partner">Become a Partner</Link></li>
          </ul>
          </div>

        </div>

        {/* Legal */}
        <div className="footer-col">
          <h4 className="footer-heading">LEGAL</h4>
          <ul>
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link to="/terms-of-services">Terms of Service</Link></li>
            <li><Link to="/disclaimer">Disclaimer</Link></li>
            <li><Link to="/awards">Certificates</Link></li>
          </ul>
        </div>

        {/* Social */}
        <div className="footer-col">
          <h4 className="footer-heading">FOLLOW US</h4>
<div className="social-icons1">
  <a
    href="https://www.facebook.com/jayrajtoursgroup"
    target="_blank"
    rel="noopener noreferrer"
  >
    <FaFacebookF />
  </a>

  <a
    href="https://www.youtube.com/channel/UCBGOrdFLRH7jXePaKgDFJAA"
    target="_blank"
    rel="noopener noreferrer"
  >
    <FaYoutube />
  </a>

  <a
    href="https://x.com/JayrajTourGroup"
    target="_blank"
    rel="noopener noreferrer"
  >
    <FaTwitter />
  </a>

  <a
    href="https://www.linkedin.com/in/jayraj-group-0723593a5/"
    target="_blank"
    rel="noopener noreferrer"
  >
    <FaLinkedinIn />
  </a>

  <a
    href="https://www.instagram.com/jayrajtours_group/"
    target="_blank"
    rel="noopener noreferrer"
  >
    <FaInstagram />
  </a>
</div>

<div className="contact-emails">
  <div className="email-item">
    <span className="email-icon">📧</span>
    <a href="mailto:info@jayrajgroup.org">info@jayrajgroup.org</a>
  </div>

  <div className="email-item">
    <span className="email-icon">🛠️</span>
    <a href="mailto:support@jayrajgroup.org">support@jayrajgroup.org</a>
  </div>
</div>


        </div>

      </div>




      <div className="footer-bottom">
        © 2025 Jayraj Group . All rights reserved.
      </div>
    </motion.footer>
  );
}

export default Footer;
